const sectionId = window.brandCollectionsectionId;
let swiperInstance = null;
let resizeTimeout = null; 

// Function to initialize Swiper
function initSwiper() {
  if (!swiperInstance) {
    swiperInstance = new Swiper(`.swiper-brand-collection-${sectionId}`, {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: `.brand-collection-next-${sectionId}.swiper-button-next`,
        prevEl: `.brand-collection-prev-${sectionId}.swiper-button-prev`,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        350: {
          spaceBetween: 10,
        },
        640: {
          spaceBetween: 30,
        },
        767: {
          spaceBetween: 32,
        },
      },
    });
  }
}

// Function to destroy Swiper
function destroySwiper() {
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }
}

// Function to check screen size and toggle Swiper
function handleResize() {
  clearTimeout(resizeTimeout); // Clear any previous resize event
  resizeTimeout = setTimeout(() => {
    const isMobile = window.innerWidth <= 767;

    if (isMobile && !swiperInstance) {
      initSwiper(); // Initialize if in mobile view
    } else if (!isMobile && swiperInstance) {
      destroySwiper(); // Destroy if in desktop view
    }
  }, 200); // Debounce time to prevent multiple calls on iOS
}

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", () => {
  handleResize(); 

  // Listen for resize and orientation changes
  window.addEventListener("resize", handleResize);
  window.addEventListener("orientationchange", handleResize);

  // Smooth scroll for links
  document.querySelectorAll(".brand-collection-link").forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
});
